export const FIRST_COLUMN_WIDTH = 300
export const INDUCTION_TESTING_COLUMN_WIDTH = 220
export const ISOLATION_IMPEDANCE_COLUMN_WIDTH = 300
export const SECOND_COLUMN_WIDTH = 450
export const PARTIAL_DISCHARGE_SECOND_COLUMN_WIDTH = 600
export const HEATING_TEST_PARAMETER_COLUMN_WIDTH = 130
export const LOSS_FACTOR_COLUMN_WIDTH = 300
export const LOSS_FACTOR_SECOND_COLUMN_WIDTH = 400
export const INDUCTION_TESTING_SECOND_COLUMN_WIDTH = 420
export const ISOLATION_IMPEDANCE_STATOR_SECOND_COLUMN_WIDTH = 680
export const ISOLATION_IMPEDANCE_ROTOR_SECOND_COLUMN_WIDTH = 300
export const COMMENT_PARAMETER_ID = -1
export const PARAMETER_UNIT_SEPARATOR = '-unit'
export const VIBRATIONS_SECOND_COLUMN_WIDTH = 2000
